"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactPixel = void 0;
const TagManager_1 = __importDefault(require("./TagManager"));
const react_facebook_pixel_1 = __importDefault(require("react-facebook-pixel"));
exports.ReactPixel = react_facebook_pixel_1.default;
exports.default = TagManager_1.default;
